import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '../../../../../app/common/common.action';
import { ModalEntregaPage } from './modal.entrega.page';
import WebapiCommon from '../../../../../app/common/util/webapi.common';
import { obterMesPorExtenso } from '../../../../../app/common/util/api-common.util';
import CommonFunctions from '../../../../../app/common/util/functions.common';
import moment from 'moment';
import {
  getUsuarioLocalStorage,
  LOCAL_STORAGE_IMPRESSORA_LAUDO,
  getImpressoraLaudoDefault,
} from '../../../../../localStorage.util';

class ModalEntregaContainer extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
      itemCarregado: false,
      entregarMaterial: false,
      entregarResultadoExame: true,
      imprimirProtocoloEntrega: false,
      openModalMaterial: false,
      historicos: [],
      blocos: [],
      laminas: [],
      impressora: null,
      existeCasseteOuLamina: true,
      relatorio: {
        laudo: '',
        paciente: '',
        exame: '',
        nrExame: '',
        data: '',
        funcionario: '',
        exameEntregueA: '',
        localDataRecebimento: '',
        documentosExternos: [],
        checkedDocumentosExternos: [],
        cpfResponsavel: '',
        cpfValido: false,
      },
      justificativaCancelamentoEntrega: '',
      showModalCancelamentoEntrega: false,
      historicoIdParaCancelamento: null,
    };
  }

  componentDidMount() {
    if (this.props.impressoras.length === 0) {
      // WebapiCommon.getImpressoras().then((response) => {
      //   this.props.commonActions.preencherImpressoras(response);
      // });
    }

    WebapiCommon.getConfiguracaoEngrega(this.props.laudoEntrega.laudo).then(
      (response) => {
        this.props.commonActions.preencherTextoProtocoloMaterial(
          response.textoEntregaMaterial
        );
        this.setState({
          imprimirProtocoloEntrega: response.imprimirProtocoloEntrega,
          existeCasseteOuLamina: response.existeCasseteOuLamina,
        });
      }
    );
  }

  componentDidUpdate() {
    if (this.props.modalEntrega && !this.state.itemCarregado) {
      this.props.commonActions.showFadeCarregando(true);

      var requests = [
        WebapiCommon.obterListagemDocumentosLaudo(
          this.props.laudoEntrega.laudo
        ),
        WebapiCommon.obterHistoricoEntrega(this.props.laudoEntrega.laudo),
      ];

      Promise.all(requests).then((response) => {
        var impressora = getImpressoraLaudoDefault();

        if (this.props.impressoras.length >= 0 && impressora === undefined) {
          impressora = JSON.stringify(this.props.impressoras[0]);
        }

        let data = new Date();
        let dataArray = data.toLocaleDateString().split('/');
        let documentosExternos = [];

        response[0].forEach((item) => documentosExternos.push(item));
        const usuario = getUsuarioLocalStorage();

        this.setState({
          itemCarregado: true,
          impressora: impressora ? JSON.parse(impressora) : null,
          historicos: response[1].map((h) => {
            return { ...h, ...{ exibirAnotacoes: false } };
          }),
          relatorio: {
            laudo: this.props.laudoEntrega.laudo,
            paciente: this.props.laudoEntrega.paciente,
            exame: this.props.laudoEntrega.exame,
            nrExame: this.props.laudoEntrega.nrExame,
            data: data.toLocaleString().split(' ')[0],
            hora: data.toLocaleString().split(' ')[1],
            funcionario: usuario.usuario,
            localDataRecebimento:
              dataArray[0] +
              ' ' +
              obterMesPorExtenso(parseInt(dataArray[1], 10)) +
              ' ' +
              dataArray[2],
            documentosExternos: documentosExternos,
            checkedDocumentosExternos: [],
            cpfValido: false,
          },
        });
        this.props.commonActions.showFadeCarregando(false);
      });
    }
  }

  render() {
    const {
      cpfResponsavel,
      exameEntregueA,
      documentosExternos,
      cpfValido,
      checkedDocumentosExternos,
    } = this.state.relatorio;

    const {
      showModalCancelamentoEntrega,
      justificativaCancelamentoEntrega,
    } = this.state;

    return (
      <ModalEntregaPage
        entregarExame={this.entregarExame.bind(this)}
        cancelarEntrega={this.cancelarEntrega.bind(this)}
        abrirSelecaoMaterial={this.abrirSelecaoMaterial.bind(this)}
        openModalMaterial={this.state.openModalMaterial}
        openModalEntrega={this.props.modalEntrega}
        closeModal={this.closeModal.bind(this)}
        closeModalMaterial={this.closeModalMaterial.bind(this)}
        historicos={this.state.historicos}
        modalOnChangeTexto={this.modalOnChangeTexto.bind(this)}
        entregarMaterial={this.state.entregarMaterial}
        entregarResultadoExame={this.state.entregarResultadoExame}
        changeEntregarMaterial={this.changeEntregarMaterial.bind(this)}
        changeResultadoExame={this.changeResultadoExame.bind(this)}
        impressoras={this.props.impressoras}
        impressora={this.state.impressora}
        activeTab={this.state.activeTab}
        blocos={this.state.blocos}
        laminas={this.state.laminas}
        checkMaterial={this.checkMaterial.bind(this)}
        altura={parseInt(this.props.altura, 10) + 15}
        changeAba={this.changeAba.bind(this)}
        abrirFecharAnotacao={this.abrirFecharAnotacao.bind(this)}
        atualizarImpressora={this.atualizarImpressora.bind(this)}
        cpfResponsavel={cpfResponsavel}
        exameEntregueA={exameEntregueA}
        imprimirProtocoloEntrega={this.state.imprimirProtocoloEntrega}
        changeImprimirProtocoloEntrega={this.changeImprimirProtocoloEntrega.bind(
          this
        )}
        existeCasseteOuLamina={this.state.existeCasseteOuLamina}
        documentosExternos={documentosExternos}
        cpfValido={cpfValido}
        checkedDocumentosExternos={checkedDocumentosExternos}
        onChangeDocExterno={this.onChangeDocExterno.bind(this)}
        toggleModalCancelamentoEntrega={this.toogleModalCancelamentoEntrega.bind(
          this
        )}
        showModalCancelamentoEntrega={showModalCancelamentoEntrega}
        setJustificativaCancelamentoEntrega={this.setJustificativaCancelamentoEntrega.bind(
          this
        )}
        justificativaCancelamentoEntrega={justificativaCancelamentoEntrega}
      />
    );
  }

  abrirSelecaoMaterial() {
    var requests = [
      WebapiCommon.getBlocos(this.props.laudoEntrega.laudo),
      WebapiCommon.getLaminas(this.props.laudoEntrega.laudo),
    ];

    Promise.all(requests).then((response) => {
      this.setState({
        blocos: response[0]
          .filter((bl) => !bl.cancelado && bl.blocoCriado)
          .map((b) => {
            b.checked = false;
            return b;
          }),
        laminas: response[1].map((l) => {
          l.checked = false;
          return l;
        }),
        openModalMaterial: true,
      });
    });
  }

  checkMaterial(tipo, item) {
    var lista = this.state[tipo];
    lista = lista.map((i) => {
      if (i.id === item.id) {
        i.checked = !i.checked;
      }
      return i;
    });

    this.setState({
      [tipo]: lista,
    });
  }

  entregar

  abrirFecharAnotacao(histId) {
    this.setState((state) => ({
      historicos: state.historicos.map((hist) => {
        if (hist.id === histId) {
          hist.exibirAnotacoes = !hist.exibirAnotacoes;
        }
        return hist;
      }),
    }));
  }

  changeAba(aba) {
    this.setState({
      activeTab: aba,
    });
  }

  closeModalMaterial() {
    this.setState({
      openModalMaterial: false,
    });
  }

  closeModal() {
    this.props.commonActions.mudarStatusModalEntrega(false, undefined);
    this.setState({
      itemCarregado: false,
      openModalMaterial: false,
      activeTab: '1',
      relatorio: {
        laudo: '',
        paciente: '',
        exame: '',
        nrExame: '',
        data: '',
        funcionario: '',
        exameEntregueA: '',
        localDataRecebimento: '',
        documentosExternos: [],
        checkedDocumentosExternos: [],
        cpfValido: false,
      },
    });
  }

  modalOnChangeTexto(el) {
    let cpfValido = this.state.relatorio.cpfValido;
    let value =
      el.currentTarget.name === 'cpfResponsavel'
        ? CommonFunctions.cpfMascaraFormatacao(el.currentTarget.value)
        : el.currentTarget.value;

    let apenasNum = value.replaceAll('.', '').replaceAll('-', '');

    if (el.currentTarget.name === 'cpfResponsavel' && apenasNum.length === 11) {
      cpfValido = CommonFunctions.validarDigitoVerificadorCPF(apenasNum);
    } else if (el.currentTarget.name === 'cpfResponsavel') {
      cpfValido = false;
    }

    this.setState({
      relatorio: {
        ...this.state.relatorio,
        [el.currentTarget.name]: value,
        cpfValido: cpfValido,
      },
    });
  }

  changeEntregarMaterial() {
    this.setState((state) => ({
      entregarMaterial: !state.entregarMaterial,
    }));
  }

  changeResultadoExame() {
    this.setState((state) => ({
      entregarResultadoExame: !state.entregarResultadoExame,
    }));
  }

  atualizarImpressora(impressora) {
    this.setState({
      impressora: impressora,
    });

    localStorage.setItem(
      LOCAL_STORAGE_IMPRESSORA_LAUDO,
      JSON.stringify(impressora)
    );
  }

  entregarExame() {
    this.props.commonActions.showFadeCarregando(true);
    const usuario = getUsuarioLocalStorage();
    const entregar = {
      laudo: parseInt(this.state.relatorio.laudo, 10),
      paciente: this.state.relatorio.paciente,
      exame: this.state.relatorio.exame,
      usuario: usuario.usuario,
      responsavel: this.state.relatorio.exameEntregueA,
      cpfResponsavel: this.state.relatorio.cpfResponsavel,
      usuarioLogado: parseInt(usuario.usuarioId, 10),
      usuarioNome: usuario.usuario,
      nrExame: this.state.relatorio.nrExame,
      texto: this.state.relatorio.anotacoesEntregaExame,
      observacaoInterna: this.state.relatorio.anotacoesInternasEntregaExame,
      registro: this.state.relatorio.laudo,
      documentoExterno: [],
      blocos: [],
      laminas: [],
    };

    if (this.state.entregarMaterial) {
      entregar.blocos = this.state.blocos
        .filter((b) => b.checked)
        .map((b) => {
          if(!b.entregue){
            return b.id;
            }
        });
        entregar.laminas = this.state.laminas
        .filter((l) => l.checked)
        .map((l) => {
          if(!l.entregue) {
            return l.id;
         }
        });
    }

    this.state.relatorio.checkedDocumentosExternos.forEach((id) =>
      entregar.documentoExterno.push(id)
    );

    WebapiCommon.entregaResultadoExame(
      this.state.relatorio.laudo,
      entregar
    ).then(() => {
      this.atualizarDataEntrega(moment().format('DD/MM/YYYY HH:mm:ss'));

      if (this.state.imprimirProtocoloEntrega) {
        this.imprimirProtocoloEntrega();
      }

      if (this.state.entregarResultadoExame) {
        this.imprimirResultadoExame();
      }

      this.closeModal();
      this.props.commonActions.showFadeCarregando(false);
    });
  }

  cancelarEntrega() {
    this.props.commonActions.showFadeCarregando(true);
    let laudo = this.state.relatorio.laudo;
    let {
      justificativaCancelamentoEntrega,
      historicoIdParaCancelamento,
    } = this.state;

    WebapiCommon.cancelarEntregaResultadoExame(
      laudo,
      historicoIdParaCancelamento,
      justificativaCancelamentoEntrega
    ).then((response) => {
      var data = null;
      var hists = this.state.historicos.map((hist) => {
        if (hist.id === historicoIdParaCancelamento) {
          hist.entregaCancelada = true;
        }

        if (
          !hist.entregaCancelada &&
          (!data || moment(hist.dataEntrega) > moment(data))
        ) {
          data = hist.dataEntrega;
        }
        return hist;
      });

      WebapiCommon.obterListagemDocumentosLaudo(laudo).then((docExt) => {
        let { relatorio } = this.state;
        relatorio.documentosExternos = [];

        docExt.forEach((item) => relatorio.documentosExternos.push(item));

        this.setState({
          historicos: hists,
          relatorio,
        });

        this.atualizarDataEntrega(data);
        this.props.commonActions.showFadeCarregando(false);
        this.toogleModalCancelamentoEntrega(null);
        this.props.commonActions.showAlerta(
          response ? 'sucesso' : 'erro',
          response
            ? 'Entrega cancelada com sucesso.'
            : 'Não foi possível cancelar a entrega',
          2000
        );
      });
    });
  }

  atualizarDataEntrega(data) {
    let listagem = [...this.props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === this.state.relatorio.laudo
    );
    listagem[listagemIndex].dataEntrega = data;
    this.props.commonActions.preencherListagem(listagem);
  }

  imprimirResultadoExame() {
    if (this.state.entregarResultadoExame) {
      this.props.commonActions.showFadeCarregando(true);
      let { impressora } = this.state;
      let etapas = [];

      WebapiCommon.obterStatusEtapasLaudo(this.state.relatorio.laudo)
      .then((response) => {
        response.forEach(e => {

          if ((e.status === 'realizado' || e.status === 'pendente' || e.status === 'conferencia' || e.status === 'revisao')) {
            etapas.push(e.etapa);
          }
        });

        WebapiCommon.imprimirLaudo(
          this.state.relatorio.laudo,
          etapas,
          "pdf"
        ).then((response) => {
          let mensagem = response
            ? 'Laudo enviado para impressão com sucesso'
            : 'Houve um erro na impressão do laudo';
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            response ? 'sucesso' : 'erro',
            mensagem,
            2000
          );

          if (response){

            var base64str = response.pdf;
            var binary = atob(base64str.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            var blob = new Blob( [view], { type: "application/pdf" });
            var url = URL.createObjectURL(blob);
            window.open(url);
          }
        });
      });
    }
  }

  imprimirProtocoloEntrega() {
    this.props.commonActions.showFadeCarregando(true);
    let { impressora } = this.state;

    var body = {
      Impressora: "pdf",
      Paciente: this.state.relatorio.paciente,
      Laudo: this.state.relatorio.laudo,
      DataEntrega: this.state.relatorio.data + ' ' + this.state.relatorio.hora,
      DataFormatada: this.state.relatorio.localDataRecebimento,
      Exame: this.state.relatorio.exame,
      NrExame: this.state.relatorio.nrExame,
      Funcionario: this.state.relatorio.funcionario,
      Responsavel: this.state.relatorio.exameEntregueA,
      CpfResponsavel: this.state.relatorio.cpfResponsavel,
      Anotacao: this.state.relatorio.anotacoesEntregaExame,
      TextoComplementar: '',
      Blocos: [],
      Laminas: [],
    };

    if (this.state.entregarMaterial) {
      body.Blocos = this.state.blocos
        .filter((b) => b.checked)
        .map((b) => {
          return b.numeroBloco;
        });
      body.Laminas = this.state.laminas
        .filter((l) => l.checked)
        .map((l) => {
          return l.label;
        });
      body.TextoComplementar = this.props.textoProtocoloEntregaMaterial;
    }

    let listaDocumentos = [];
    let i = 0;

    for (i = 0; i < this.state.relatorio.documentosExternos.length; i++) {
      if (this.state.relatorio.documentosExternos[i].entregue) {
        listaDocumentos.push(
          this.state.relatorio.documentosExternos[i].nomeDocumento
        );
      }
    }

    for (
      i = 0;
      i < this.state.relatorio.checkedDocumentosExternos.length;
      i++
    ) {
      let documento = this.state.relatorio.documentosExternos
        .filter(
          // eslint-disable-next-line no-loop-func
          (d) => d.id === this.state.relatorio.checkedDocumentosExternos[i]
        )
        .map((d) => {
          return d.nomeDocumento;
        });

      listaDocumentos.push(documento[0]);
    }

    body.DocumentosExternos = listaDocumentos;

    WebapiCommon.imprimirProtocolo(body).then((response) => {
      let mensagem = response
        ? 'Protocolo enviado para impressão com sucesso'
        : 'Houve um erro na impressão do protocolo';

      this.props.commonActions.showFadeCarregando(false);

      const sucesso = response ? 'sucesso' : 'erro';

      this.props.commonActions.showAlerta(
        sucesso,
        mensagem,
        2000
      );

      if (sucesso){
        var base64str = response.pdf;
        var binary = atob(base64str.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }

        var blob = new Blob( [view], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);
        window.open(url);
      }
    });
  }

  changeImprimirProtocoloEntrega = () =>
    this.setState((state) => ({
      imprimirProtocoloEntrega: !state.imprimirProtocoloEntrega,
      entregarMaterial: false,
    }));

  onChangeDocExterno = (id) => {
    let { relatorio } = this.state;
    let index = relatorio.checkedDocumentosExternos.findIndex(
      (el) => el === id
    );

    if (index >= 0) {
      relatorio.checkedDocumentosExternos.splice(index, 1);
    } else {
      relatorio.checkedDocumentosExternos.push(id);
    }

    this.setState({ relatorio });
  };

  toogleModalCancelamentoEntrega = (historicoIdParaCancelamento) =>
    this.setState((state) => ({
      showModalCancelamentoEntrega: !state.showModalCancelamentoEntrega,
      historicoIdParaCancelamento: state.showModalCancelamentoEntrega
        ? null
        : historicoIdParaCancelamento,
    }));

  setJustificativaCancelamentoEntrega = (event) =>
    this.setState({
      justificativaCancelamentoEntrega: event.currentTarget.value,
    });
}

const mapStateToProps = (state) => {
  return {
    modalEntrega: state.commonReducer.modalEntrega,
    laudoEntrega: state.commonReducer.laudoEntrega,
    impressoras: state.commonReducer.impressoras,
    textoProtocoloEntregaMaterial:
      state.commonReducer.textoProtocoloEntregaMaterial,
    listagem: state.commonReducer.listagem,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(ModalEntregaContainer);



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/entrega/modal.entrega.container.js